module.exports = __webpack_public_path__ + "static/media/icon_nosotros_seguro.c4650287.svg";